export function setRegister(state, payload) {
    state.register = payload
}